module.exports = __webpack_public_path__ + "static/media/competencies.b72c8780.svg";